import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './AdminPanel.css'; // We'll style with branding colors

<button
  onClick={() => {
    localStorage.removeItem('admin_logged_in');
    window.location.href = '/login';
  }}
  style={{
    position: 'absolute',
    top: 20,
    right: 20,
    backgroundColor: '#FF0000',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '6px',
    cursor: 'pointer'
  }}
>
  Logout
</button>

const categories = ['Tech', 'Business', 'Marketing', 'Finance', 'Other'];

const AdminPanel = ({ blogs, setBlogs }) => {
  const [form, setForm] = useState({
    id: '',
    title: '',
    slug: '',
    content: '',
    coverImage: '',
    category: '',
    backlink: '',
    date: ''
  });
  const [isEditing, setIsEditing] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const generateSlug = (title) =>
    title.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

  const handleSubmit = (e) => {
    e.preventDefault();
    const slug = isEditing ? form.slug : generateSlug(form.title);
    if (isEditing) {
      setBlogs(blogs.map(blog => (blog.id === form.id ? { ...form, slug } : blog)));
    } else {
      setBlogs([...blogs, { ...form, id: Date.now(), slug }]);
    }
    setForm({ id: '', title: '', slug: '', content: '', coverImage: '', category: '', backlink: '', date: '' });
    setIsEditing(false);
  };

  const handleEdit = (blog) => { setForm(blog); setIsEditing(true); };
  const handleDelete = (id) => { if(window.confirm('Delete this blog?')) setBlogs(blogs.filter(blog => blog.id !== id)); };

  return (
    <div className="admin-panel">
      <h1>📝 Blog Admin Panel</h1>
      <form onSubmit={handleSubmit} className="admin-form">
        <input type="text" name="title" placeholder="Title" value={form.title} onChange={handleChange} required />
        <input type="text" name="coverImage" placeholder="Cover Image URL" value={form.coverImage} onChange={handleChange} />
        {form.coverImage && <img src={form.coverImage} alt="Preview" className="cover-preview" />}
        <input type="date" name="date" value={form.date} onChange={handleChange} />
        <select name="category" value={form.category} onChange={handleChange}>
          <option value="">Select Category</option>
          {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
        </select>
        <input type="url" name="backlink" placeholder="Backlink URL" value={form.backlink} onChange={handleChange} />
        <ReactQuill theme="snow" value={form.content} onChange={(value) => setForm({ ...form, content: value })} />
        <button type="submit" className="btn-primary">{isEditing ? 'Update Blog' : 'Add Blog'}</button>
      </form>

      <h2>Existing Blogs</h2>
      <ul className="blog-list">
        {blogs.map(blog => (
          <li key={blog.id} className="blog-item">
            <div>
              <strong>{blog.title}</strong> ({blog.date}) <em>{blog.category}</em>
            </div>
            <div>
              <button className="btn-secondary" onClick={() => handleEdit(blog)}>Edit</button>
              <button className="btn-danger" onClick={() => handleDelete(blog.id)}>Delete</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminPanel;
